import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import ObjectViewer from '../Common/ObjectViewer';

const Ad = () => {
  const dispatch = useDispatch();
  const { account_id, ad_id } = useParams();
  const { ad, isFlexible } = useSelector((state) => state.general);

  const determineIfFlexible = (creativeId) => {
    const payload = {
      reduxField: 'isFlexible',
      route: 'accountDashboard/determineAdFormat',
      accountId: account_id,
      adId: ad_id,
    };
    if (creativeId) {
      payload.creativeId = creativeId;
    }

    dispatch(apiAction(payload));
  };

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'ad',
        route: 'accountDashboard/getAdById',
        accountId: account_id,
        adId: ad_id,
      })
    );
  }, [dispatch, account_id, ad_id]);
  console.log({ ad, isFlexible });
  return ad?.id ? (
    <>
      <div>
        <Link className='btn btn-outline-dark' to={`/adset/${account_id}/${ad?.adset_id}`}>
          Back to AdSet
        </Link>
      </div>
      <div className='mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <h3>Ad Overview</h3>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
          <h5>
            Ad Data from Facebook <span className='text-primary'>getAdById(adId, token)</span>
          </h5>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          {ad?.id ? <ObjectViewer data={ad} /> : <Spinner />}
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          Creative: <Link to={`/creative/${account_id}/${ad.creative?.id}`}>{ad.creative?.id}</Link>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <button onClick={() => determineIfFlexible(ad.creative?.id)}>Determine If Flexible</button>
        </div>
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default Ad;
